import React, { useEffect } from "react";
import { PageWrapper } from "components/ui/PageWrapper";

import "styles/main.css";
import { FormInput } from "components/ui/FormInput";
import { useForm } from "react-hook-form";
import { ButtonLoader } from "components/Loader/ButtonLoader";

import { ComponentLoader } from "components/Loader/ComponentLoader";
import { ErrorComponent } from "components/Alerts/Error";
import {
  GetProcessWhatIsSection,
  UpdateProcessWhatIsSection,
} from "rest/processWhatIsSection";

export default function ProcessWhatIsSectionPage() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const getSection = GetProcessWhatIsSection();
  const updateSection = UpdateProcessWhatIsSection();

  useEffect(() => {
    const data = getSection?.data?.data;
    if (data) {
      reset({
        heading: data.heading || "",
        text_1: data.text_1 || "",
        flow_heading: data.flow_heading || "",
        step_1: data.step_1 || "",
        step_2: data.step_2 || "",
        step_3: data.step_3 || "",
        step_4: data.step_4 || "",
        step_5: data.step_5 || "",
        step_6: data.step_6 || "",
        text_2: data.text_2 || "",
        box_text: data.box_text || "",
      });
    }
  }, [getSection?.data?.data, reset]);

  const onSubmit = (data) => {
    updateSection.mutate(data);
  };

  return (
    <div className="process_what_is_section_page">
      <PageWrapper
        slug="process-what-is-section"
        name="What Are Process Chemistry CRO Services?"
      />

      {getSection?.isError && (
        <ErrorComponent message="OOPS ! something went wrong please try again later" />
      )}

      {getSection?.isPending ? (
        <ComponentLoader />
      ) : (
        <div className="home_banner_input">
          <form onSubmit={handleSubmit(onSubmit)} className="row mt-4 mb-3">
            <div className="mb-3 col-md-12">
              <label htmlFor="heading" className="form-label">
                Heading
              </label>
              <FormInput
                type="text"
                name="heading"
                placeholder="What Are Process Chemistry CRO Services?"
                {...register("heading", { required: true })}
              />
              {errors?.heading && (
                <p className="errorMessage">Heading is required</p>
              )}
            </div>

            <div className="mb-3 col-md-12">
              <label htmlFor="text_1" className="form-label">
                Paragraph 1
              </label>
              <textarea
                className="form-control"
                rows="4"
                placeholder="First paragraph"
                {...register("text_1")}
              />
            </div>

            <div className="col-12">
              <hr className="my-4" />
              <h5 className="fw-bold mb-3">
                "How Process Chemistry Works" Flow
              </h5>
            </div>

            <div className="mb-3 col-md-6">
              <label htmlFor="flow_heading" className="form-label">
                Flow Card Heading
              </label>
              <FormInput
                type="text"
                name="flow_heading"
                placeholder="How Process Chemistry Works"
                {...register("flow_heading")}
              />
            </div>

            <div className="mb-3 col-md-4">
              <label htmlFor="step_1" className="form-label">
                Step 1
              </label>
              <FormInput
                type="text"
                name="step_1"
                placeholder="Route Evaluation"
                {...register("step_1")}
              />
            </div>
            <div className="mb-3 col-md-4">
              <label htmlFor="step_2" className="form-label">
                Step 2
              </label>
              <FormInput
                type="text"
                name="step_2"
                placeholder="Reaction Scouting"
                {...register("step_2")}
              />
            </div>
            <div className="mb-3 col-md-4">
              <label htmlFor="step_3" className="form-label">
                Step 3
              </label>
              <FormInput
                type="text"
                name="step_3"
                placeholder="Process Optimization"
                {...register("step_3")}
              />
            </div>
            <div className="mb-3 col-md-4">
              <label htmlFor="step_4" className="form-label">
                Step 4
              </label>
              <FormInput
                type="text"
                name="step_4"
                placeholder="Impurity Control"
                {...register("step_4")}
              />
            </div>
            <div className="mb-3 col-md-4">
              <label htmlFor="step_5" className="form-label">
                Step 5
              </label>
              <FormInput
                type="text"
                name="step_5"
                placeholder="Analytical Support"
                {...register("step_5")}
              />
            </div>
            <div className="mb-3 col-md-4">
              <label htmlFor="step_6" className="form-label">
                Step 6
              </label>
              <FormInput
                type="text"
                name="step_6"
                placeholder="Scale-Up Readiness"
                {...register("step_6")}
              />
            </div>

            <div className="mb-3 col-md-12">
              <label htmlFor="text_2" className="form-label">
                Paragraph 2
              </label>
              <textarea
                className="form-control"
                rows="4"
                placeholder="Second paragraph"
                {...register("text_2")}
              />
            </div>

            <div className="col-12">
              <hr className="my-4" />
              <h5 className="fw-bold mb-3">Blue Box Text</h5>
            </div>

            <div className="mb-3 col-md-12">
              <label htmlFor="box_text" className="form-label">
                Text
              </label>
              <textarea
                className="form-control"
                rows="3"
                placeholder="AAPharmaSyn combines process chemistry expertise..."
                {...register("box_text")}
              />
            </div>

            {updateSection?.isPending ? (
              <div className="col-12 text-center">
                <ButtonLoader />
              </div>
            ) : (
              <div className="mb-3 col-12">
                <input type="submit" value="Save Section" className="input_submit" />
              </div>
            )}
          </form>
        </div>
      )}
    </div>
  );
}
